import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken, fetchTokenFile } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingUsers = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_USERS}`, "get");
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingUsers(body.users));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingUsers = (users) => ({
  type: types.USER_START_LOADING,
  payload: users,
});

export const startLoadingUsersPaginated = (page, size, access) => {
  return async (dispatch) => {
    const query = access ? `?access=${encodeURIComponent(access)}` : "";
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_USERS}`, `get/${page}/${size}${query}`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingUsersPaginated(body.usersPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingUsersPaginated = (usersPaginated) => ({
  type: types.USER_START_LOADING_PAGINATED,
  payload: usersPaginated,
});

export const selectUser = (user) => ({
  type: types.USER_SELECT,
  payload: user,
});

export const selectUserForPreferences = (user) => ({
  type: types.USER_SELECT_FOR_PREFERENCES,
  payload: user,
});

export const selectUserInUserRole = (user) => ({
  type: types.USER_SELECT_IN_USER_ROLE,
  payload: user,
});

/**
 * Funcion para iniciar la actualizacion de usuarios
 * @returns async dispatch
 */
export const userStartUpdate = (user, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_USERS}`,
        `update/${user.id}`,
        user,
        "PUT"
      );
      const body = await resp.json();

      if (body.ok) {
        dispatch(userUpdated(user));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-user");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
          Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

        }
        if (body.code === "bak-aut-tok-inv-001") {
          Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: userActions, userStartUpdate', { 'error': error });
    }
  };
};

const userUpdated = (user) => {
  return {
    type: types.USER_UPDATE,
    payload: user,
  };
};

export const userStartUpdateForPreferences = (user, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_USERS}`,
        `update/${user.id}`,
        user,
        "PUT"
      );
      const body = await resp.json();

      if (body.ok) {
        dispatch(userUpdatedForPreferences(user));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {

          }
        });

      } else {
        if (body.code === "bak-error-001") {
          Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

        }
        if (body.code === "bak-aut-tok-inv-001") {
          Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: userActions, userStartUpdateForPreferences', { 'error': error });
    }
  };
};

const userUpdatedForPreferences = (user) => {
  return {
    type: types.USER_UPDATE_FOR_PREFERENCES,
    payload: user,
  };
};

export const userStartDelete = (id) => {
  return async (dispatch, getState) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_USERS}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {
              if (body.ok) {
                dispatch(userDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                  Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: userActions, userStartDelete', { 'error': error });
    }
  };
};

const confirmUserAdminAction = async (titleKey, textKey) => {
  const result = await Swal.fire({
    title: t(titleKey),
    text: t(textKey),
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: t("buttons.confirm"),
    cancelButtonText: t("buttons.cancel"),
  });
  return result.isConfirmed;
};

const handleUserAdminError = (dispatch, body) => {
  if (body.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
  }
  if (body.code === "bak-error-block-self-001") {
    Swal.fire(t("titles.error"), t("alerts.validation.bak-error-block-self-001"), "error");
  }
  if (body.code === "bak-error-usu-004") {
    Swal.fire(t("titles.error"), t("alerts.validation.bak-error-usu-004"), "error");
  }
  if (body.code === "bak-aut-tok-inv-001") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
  }
  if (body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
    dispatch(startLogout());
  }
};

export const userStartSetBlocked = (id, blocked, reload) => {
  return async (dispatch) => {
    try {
      const accepted = await confirmUserAdminAction(
        blocked ? "admin-user.page.block" : "admin-user.page.unblock",
        blocked ? "admin-user.page.confirm-block" : "admin-user.page.confirm-unblock"
      );
      if (!accepted) {
        return;
      }
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_USERS}`,
        `blocked/${id}`,
        { blocked },
        "PUT"
      );
      const body = await resp.json();
      if (body.ok) {
        Swal.fire(t("titles.success"), t(blocked ? "admin-user.page.blocked-done" : "admin-user.page.unblocked-done"), "success");
        if (reload) {
          reload();
        }
      } else {
        handleUserAdminError(dispatch, body);
      }
    } catch (error) {
      debugErrorActions(":: userActions, userStartSetBlocked", { error });
    }
  };
};

export const userStartActivateAccess = (id, reload) => {
  return async (dispatch) => {
    try {
      const accepted = await confirmUserAdminAction(
        "admin-user.page.activate",
        "admin-user.page.confirm-activate"
      );
      if (!accepted) {
        return;
      }
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_USERS}`,
        `activate-access/${id}`,
        {},
        "PUT"
      );
      const body = await resp.json();
      if (body.ok) {
        Swal.fire(t("titles.success"), t("admin-user.page.activated-done"), "success");
        if (reload) {
          reload();
        }
      } else {
        handleUserAdminError(dispatch, body);
      }
    } catch (error) {
      debugErrorActions(":: userActions, userStartActivateAccess", { error });
    }
  };
};

const userDeleted = (id) => {
  return {
    type: types.USER_DELETE,
    payload: id,
  };
};

export const startSearchingUsers = (textSearch) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_USERS}`, `search/${textSearch}`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingSearchUsers(body.users.rows));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingSearchUsers = (users) => ({
  type: types.USER_START_SEARCH,
  payload: users,
});

export const startSearchingUsersPaginated = (textSearch, page, size, access) => {
  return async (dispatch) => {
    const query = access ? `?access=${encodeURIComponent(access)}` : "";
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USERS}`,
      `search/${textSearch}/${page}/${size}${query}`
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(searchingUsersPaginated(body.usersPaginated));
    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingUsersPaginated = (usersPaginated) => ({
  type: types.USER_START_SEARCH_PAGINATED,
  payload: usersPaginated,
});

export const cleanSearchingUsersPaginated = () => ({
  type: types.USER_CLEAN_SEARCH_PAGINATED,
});

export const userStartRegisterAdmin = (user, navigate) => {

  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_USERS}`, "add-admin", user, "POST");

    const body = await resp.json();

    debugLogActions(':: userActions, userStartRegisterAdmin', { 'body': body });

    if (body.ok) {
      dispatch(userRegisterAdmin(body.user));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-user");
          }, 5000);
        }
      });


    } else {
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");

      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-validation-user-001") {
        Swal.fire(t("titles.error"), t("validation.bak-validation-user-001"), "error");

      }

    }
  };
};

const userRegisterAdmin = (user) => ({
  type: types.USER_START_REGISTER_ADMIN,
  payload: user,
});

export const userClean = () => ({
  type: types.USER_CLEAN,
});

export const userSetSearchText = (searchText) => ({
  type: types.USER_SET_SEARCH_TEXT,
  payload: searchText,
});

export const userCleanSearchText = () => ({
  type: types.USER_CLEAN_SEARCH_TEXT,
});

export const userCleanUserInUserRole = () => ({
  type: types.USER_CLEAN_USER_IN_USER_ROLE,
});

/*
const userRegister = (user) => ({
  type: types.USER_START_REGISTER,
  payload: user,
});
*/

export const userCleanSaved = () => ({
  type: types.USER_CLEAN_SAVED,
});

const setUserPreferences = (preference) => ({
  type: types.USER_PREFERENCES_SET,
  payload: preference,
});

const preferenceError = (dispatch, body) => {
  if (body.code === "bak-aut-tok-inv-001" || body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
    return;
  }
  Swal.fire(t("titles.error"), body.msg || t("alerts.validation.bak-error-001"), "error");
};

export const userStartLoadOwnProfile = (userId) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USERS}`,
      `get/${userId}`
    );
    const body = await resp.json();
    if (body.ok && body.user) {
      dispatch(selectUserForPreferences({
        ...body.user,
        passwordEncrypt: body.user.password,
      }));
    }
    return body;
  };
};

export const userStartLoadPreferences = () => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_PREFERENCES}`,
      "me"
    );
    const body = await resp.json();
    if (body.ok) {
      dispatch(setUserPreferences(body.preference));
    }
    return body;
  };
};

export const userStartSavePreferences = (partial) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_PREFERENCES}`,
      "me",
      partial,
      "PUT"
    );
    const body = await resp.json();
    if (body.ok) {
      dispatch(setUserPreferences(body.preference));
    } else {
      preferenceError(dispatch, body);
    }
    return body;
  };
};

export const userStartUploadAvatar = (file) => {
  return async (dispatch) => {
    const form = new FormData();
    form.append("avatar", file);
    const resp = await fetchTokenFile(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_PREFERENCES}`,
      "avatar",
      form,
      "POST"
    );
    const body = await resp.json();
    if (body.ok) {
      dispatch(setUserPreferences(body.preference));
    } else {
      preferenceError(dispatch, body);
    }
    return body;
  };
};

export const userStartRequestPasswordChange = () => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_PREFERENCES}`,
      "password/request",
      {},
      "POST"
    );
    const body = await resp.json();
    if (!body.ok) preferenceError(dispatch, body);
    return body;
  };
};

export const userStartRequestEmailChange = (email) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_PREFERENCES}`,
      "email/request",
      { email },
      "POST"
    );
    const body = await resp.json();
    if (!body.ok) preferenceError(dispatch, body);
    return body;
  };
};
